module.exports = "pegasus/assets/themelp1/webinar/101.png";